import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IPlotForSale, StatusFilterEnum } from './types';
import { initialState } from './types/initialState';
import { PlotFacingTypeEnum, PlotOwnerTypeEnum, PlotTypeEnum, PropertyAvailabilityStatusEnum } from 'pages/PropertyListing/types';
import { PlotSizeUnitTypeEnum } from 'pages/ServiceOrder/types';

export const useClinicSlice = createSlice({
  name: 'plotForSale',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setButtonLoading: (state, action: PayloadAction<boolean>) => {
      state.buttonLoading = action.payload;
    },
    setSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    setPageNo: (state, action: PayloadAction<number>) => {
      state.pageNo = action.payload;
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
    },
    setTotalRow: (state, action: PayloadAction<number>) => {
      state.totalRow = action.payload;
    },
    setOrderBy: (state, action: PayloadAction<string>) => {
      state.orderBy = action.payload;
    },
    setOrderDir: (state, action: PayloadAction<string>) => {
      state.orderDir = action.payload;
    },
    setEndDate: (state, action: PayloadAction<string | null>) => {
      state.endDate = action.payload;
    },
    setStartDate: (state, action: PayloadAction<string | null>) => {
      state.startDate = action.payload;
    },
    setStatusFilter: (state, action: PayloadAction<StatusFilterEnum>) => {
      state.status = action.payload;
    },

    doGetList: (state) => {},
    setList: (state, action: PayloadAction<Array<IPlotForSale>>) => {
      state.List = action.payload;
    },
    setDataInForm: (state, action: PayloadAction<IPlotForSale>) => {
      state.form = action.payload;
      //@ts-ignore
      state.form.location.lat = action.payload.location.coordinates[1];
      //@ts-ignore
      state.form.location.lng = action.payload.location.coordinates[0];
    },
    clearForm: (state) => {
      state.form = {
        _id: '',
        address: '',
        assetNo: '',
        plotNo: '',
        location: {
          lat: 0,
          lng: 0,
          type: 'Point',
          coordinates: []
        },
        pricePerSqft: '',
        plotSize: '',
        plotType: PlotTypeEnum.Null,
        ventureName: '',
        builderName: '',
        approvalStatus: 2,
        createdAt: '',
        updatedAt: '',
        plotSizeUnit: PlotSizeUnitTypeEnum.Null,
        plotWidth: '',
        plotLength: '',
        additionalInfo: '',
        isActive: false,
        approvals: [],
        availabilityStatus: PropertyAvailabilityStatusEnum.NULL,
        images: [],
        name: '',
        plotFacing: PlotFacingTypeEnum.NULL,
        locationHighlights:"",
        plotSeller: PlotOwnerTypeEnum.DEALER
      };
    },
    doGetById: (
      state,
      action: PayloadAction<{
        id: string;
      }>
    ) => {
      state.loading = true;
    },

    doDelete: (
      state,
      action: PayloadAction<{
        id: string;
        callback: () => void;
      }>
    ) => {},
    doChangeStatus: (
      state,
      action: PayloadAction<{
        id: string;
        callback: () => void;
      }>
    ) => {}
  }
});

export const { reducer, actions, name: sliceKey } = useClinicSlice;
